<template>
  <v-dialog v-model="showAmbientConditions">
    <div class="pt-8 pr-8 pb-8 pl-8 u-bg--white">
      <h3 class="u-text-align-center">{{ $t('ambient_conditions.label') }}</h3>
      <p class="mt-6 mb-4">{{ $t('ambient_conditions.info') }}</p>
      <table v-if="isMobile" class="chosen-results">
        <thead>
          <th class="results__label u-font-weight-600 u-text-transform-uppercase">{{ $t('ambient_modal.type') }}, {{ $t('ambient_modal.ambient') }}</th>
          <th class="results__label u-font-weight-600 u-text-transform-uppercase">{{ $t('ambient_modal.cold_room') }}</th>
        </thead>
        <tbody>
          <tr>
            <td>
              <span class="u-display-block">{{ $t('coldroom.low_temperature.label') }}</span>
              <span class="u-display-block">{{ $t('coldroom.low_temperature.ambient_conditions') }}</span>
            </td>
            <td>{{ $t('coldroom.low_temperature.cold_room_conditions') }}</td>
          </tr>
          <tr>
            <td>
              <span class="u-display-block">{{ $t('coldroom.normal_temperature.label') }}</span>
              <span class="u-display-block">{{ $t('coldroom.normal_temperature.ambient_conditions') }}</span>
            </td>
            <td>{{ $t('coldroom.normal_temperature.cold_room_conditions') }}</td>
          </tr>
          <tr>
            <td>
              <span class="u-display-block">{{ $t('coldroom.normal_temperature_2.name"') }}</span>
              <span class="u-display-block">{{ $t('coldroom.normal_temperature_2.ambient_conditions') }}</span>
            </td>
            <td>{{ $t('coldroom.normal_temperature_2.cold_room_conditions') }}</td>
          </tr>
        </tbody>
      </table>
      <table v-else class="chosen-results">
        <thead>
          <th class="results__label u-font-weight-600 u-text-transform-uppercase">{{ $t('ambient_conditions.type') }}</th>
          <th class="results__label u-font-weight-600 u-text-transform-uppercase">{{ $t('ambient_conditions.label') }}</th>
          <th class="results__label u-font-weight-600 u-text-transform-uppercase">{{ $t('ambient_conditions.cold_room_conditions') }}</th>
        </thead>
        <tbody>
          <tr>
            <td>{{ $t('coldroom.low_temperature.label') }}</td>
            <td>{{ $t('coldroom.low_temperature.ambient_conditions') }}</td>
            <td>{{ $t('coldroom.low_temperature.cold_room_conditions') }}</td>
          </tr>
          <tr>
            <td>{{ $t('coldroom.normal_temperature.label') }}</td>
            <td>{{ $t('coldroom.normal_temperature.ambient_conditions') }}</td>
            <td>{{ $t('coldroom.normal_temperature.cold_room_conditions') }}</td>
          </tr>
          <tr>
            <td>{{ $t('coldroom.normal_temperature_2.name') }}</td>
            <td>{{ $t('coldroom.normal_temperature_2.ambient_conditions') }}</td>
            <td>{{ $t('coldroom.normal_temperature_2.cold_room_conditions') }}</td>
          </tr>
        </tbody>
      </table>
      <p class="u-color--darkgrey pt-4">
        {{ $t('ambient_conditions.disclaimer') }}
      </p>
      <div class="mt-6 u-text-align-center">
        <button class="btn btn--primary" @click="closeAmbientConditions">{{
          $t('common.close')
        }}</button>
      </div>
  </div>
  </v-dialog>
</template>

<script>
export default {
  name: 'AmbientConditions',
  props: [
    'showAmbientConditions',
    'closeAmbientConditions'
  ],
  data () {
    return {
      isMobile: false
    }
  },
  beforeDestroy () {
    if (typeof window === 'undefined')  {
      return window.removeEventListener('resize', this.onResize, { passive: true })
    }
  },
  methods: {
    onResize () {
      this.isMobile = window.innerWidth < 720
    }
  },
  mounted () {
    this.onResize();
    window.addEventListener('resize', this.onResize, { passive: true });
  }
}
</script>
